import React, { Component } from "react";
import classnames from "classnames";
import NavMenuItem from "./NavMenuItem";
import styles from "./NavMenu.module.scss";
class NavMenu extends Component {
  state = {
    activePath: []
  };
  handleOpenSubMenu = page => {
    this.setState(({
      activePath
    }) => {
      if (page.level === activePath.length - 1) {
        activePath.pop();
        activePath.push(page.id);
      } else {
        activePath.push(page.id);
      }
      return {
        activePath
      };
    });
  };
  handleCloseSubMenu = page => {
    this.setState(({
      activePath
    }) => {
      const newPath = activePath.splice(0, page.level);
      return {
        activePath: newPath
      };
    });
  };
  renderSubMenus = menuItem => {
    const {
      isMobile,
      itemActive,
      itemClass,
      linkClass
    } = this.props;
    const {
      activePath
    } = this.state;
    return menuItem.hasChildren ? /*#__PURE__*/React.createElement("ul", {
      onMouseLeave: !isMobile ? () => this.handleCloseSubMenu(menuItem) : undefined,
      className: `dropdown-menu ${activePath.includes(menuItem.id) ? "show" : ""}`,
      tabIndex: "-1"
    }, menuItem.children.map(child => /*#__PURE__*/React.createElement("li", {
      key: child.id,
      className: classnames({
        dropdown: child.hasChildren,
        [itemClass]: true,
        [itemActive]: menuItem.active
      })
    }, /*#__PURE__*/React.createElement(NavMenuItem, {
      isMobile: isMobile,
      onOpenSubMenu: this.handleOpenSubMenu,
      onCloseSubMenu: this.handleCloseSubMenu,
      isSubMenuOpen: activePath.includes(child.id),
      className: linkClass,
      menuItem: child,
      hasChildren: child.hasChildren
    }), !!child.hasChildren && this.renderSubMenus(child))), /*#__PURE__*/React.createElement("li", {
      className: "menu",
      tabIndex: "-1"
    })) : null;
  };
  render() {
    const {
      menu,
      linkClass,
      isMobile,
      className,
      itemClass,
      itemActive,
      onlyTopLevel,
      navLinksColor
    } = this.props;
    const {
      activePath
    } = this.state;
    if (!(menu instanceof Array)) return null;
    return /*#__PURE__*/React.createElement("ul", {
      className: classnames(styles.menu, className),
      onMouseLeave: !isMobile ? () => this.handleCloseSubMenu({
        level: 0
      }) : undefined,
      style: {
        pointerEvents: "auto"
      }
    }, menu.map(page => /*#__PURE__*/React.createElement("li", {
      key: page.id,
      className: classnames({
        dropdown: page.hasChildren,
        [itemClass]: true,
        [itemActive]: page.active
      })
    }, /*#__PURE__*/React.createElement(NavMenuItem, {
      isMobile: isMobile,
      onOpenSubMenu: this.handleOpenSubMenu,
      onCloseSubMenu: this.handleCloseSubMenu,
      isSubMenuOpen: activePath.includes(page.id),
      className: linkClass,
      menuItem: page,
      hasChildren: page.hasChildren && !onlyTopLevel,
      navLinksColor: navLinksColor
    }), !onlyTopLevel && this.renderSubMenus(page))));
  }
}
export default NavMenu;
//# sourceMappingURL=NavMenuComponent.js.map